import { post, get } from "@/request/http";

// 获取管理员列表
// http://showdoc.mools.net/web/#/13?page_id=129
export const selectAdmin = p =>
    post(
        "/admin/getAdminList",
        {
            page: p.page,
            pagesize: p.size,
            name: p.name,
            personalId: p.personalId
        },
        res => {
            return {
                data: res.adminListShow,
                total: res.adminCount
            };
        }
    );

// 删除用户
export const deleteAdmin = p => post("/admin/deleteAdmin", p);

// 修改用户权限
export const updateAdminAuth = p => post("/admin/updateAdminAuth", p);

// 获取学院列表
export const getCollegeList = p => get("/lab/getCollegeList", p);

// 获取实验室列表
export const getLaboratoryList = p => get("/lab/getLaboratoryList", p);
